/*
 * The band that names the switcher, near the bottom of the signed-out page.
 *
 * The nine ovals are drawn here rather than mounting <ZodiacLauncher/> a
 * second time: this is a picture of the control, not the control. A second
 * live launcher on one page would be a second panel and a second trigger for
 * the same session check.
 */
import { Link } from "react-router-dom";
import s from "./landing.module.css";

export default function ZodiacBand() {
  return (
    <div className={s.band}>
      <div className={s.bandLeft}>
        <span className={s.ovals} aria-hidden="true">
          {Array.from({ length: 9 }).map((_, i) => (
            <i key={i} />
          ))}
        </span>
        <span className={s.bandText}>
          <h2 className={`${s.bandTitle} ${s.display}`}>Indexx Zodiac</h2>
          <p className={s.bandBody}>
            The switcher in the corner of every product. Open it anywhere and move to any
            of the other fifteen — already signed in, nothing asks again.
          </p>
        </span>
      </div>
      <Link className={s.bandLink} to="/how-master-login-works">
        How it works
      </Link>
    </div>
  );
}
